module.exports = __webpack_public_path__ + "img/MaskGroup5.2afe0246.svg";